import axios from "axios";
import { secureStorage } from "./SecureStorage";
var axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
    headers: {
        "Content-type": "application/json",
    }
});

console.log( process.env.REACT_APP_BASEURL,"edrtgybh")

axiosInstance.interceptors.request.use(
    config => {
        //let token = store.getState().authReducer.token;
        let s_token = localStorage.getItem('token');

        console.log('dfffff',s_token)
        
        if(!config.headers["Authorization"]){
        config.headers["Authorization"] = `Bearer ${s_token}`;
        }
        return config;
    },
    error => {
        Promise.reject(error);
    }
);
axiosInstance.interceptors.response.use(
    (response) => {
        return response
    },
    
     (error) => {
            const prevRequest = error?.config;
            console.log(prevRequest , "sdvhdovdovbdofuv")
            const refreshToken = secureStorage.getItem("refreshToken")
            console.log(error.response , "dsfjrfierouer")
            if (error.response && (error.response.status === 401 || error.response.status === 403) && !prevRequest?.sent) {
                prevRequest.sent = true
                axios.post(`${process.env.REACT_APP_BASEURL}auth/token/refresh`,{
                    refreshToken: refreshToken
                }).then((res) =>{
                    prevRequest.headers['Authorization'] = `Bearer ${res.data.access_token}`;
                     secureStorage.setItem('token' , res?.data?.access_token)
                     secureStorage.setItem('refreshToken' , res?.data?.refresh_token)
                    
                }).catch(err =>{             
                
                })
  
    return axiosInstance(prevRequest);
            }

            return Promise.reject(error)

    },
)

export default axiosInstance;


export async function callApi() {
    var data = new FormData();
    // @ts-ignore
    data.append('username', process.env.REACT_APP_USERNAME);
    // @ts-ignore
    data.append('password', process.env.REACT_APP_PASSWORD);
    // @ts-ignore
    data.append('grant_type', process.env.REACT_APP_GRANT_TYPE);
    // @ts-ignore
    await axios.post(process.env.REACT_APP_BASEURL + process.env.REACT_APP_TOKEN, data, {
        // @ts-ignore
        auth: { username: process.env.REACT_APP_AUTH_USERNAME, password: process.env.REACT_APP_AUTH_PASSWORD }
    }).then(result => {
        secureStorage.setItem("token", result?.data?.access_token);
        // localStorage.set(res.access, 'token')
    // return axios(originalRequest)
    });
}
